import PlayerManager from "../../../service/player-manager";
import SocketService from "../../../service/socket";
import ToastService from "../../../service/toast-service";
import RoomService from "../../../service/rooms-service";
import AddSongFlow from "../../../service/add-song-flow";

const currentRoomId = () => {
  const {
    isJoined,
    room: { id },
  } = SocketService.getState();
  return isJoined && id;
};

const handlePlay = ({ roomInfo, index }) => {
  const { id: reqRoomId } = roomInfo;
  if (reqRoomId === currentRoomId()) {
    SocketService.play(index);
    PlayerManager.playAtIdx(index);
  } else {
    ToastService.errorToast("You have not synced with this room");
  }
};

const handleRemove = async ({ roomInfo, index, refresh }) => {
  const { id: reqRoomId } = roomInfo;
  if (reqRoomId === currentRoomId()) {
    PlayerManager.deleteFromQueue(index);
    await RoomService.removeSong({ roomId: reqRoomId, index });
    SocketService.remove(index);
    refresh();
  } else {
    ToastService.errorToast("You have not synced with this room");
  }
};

const handleAdd = async ({ roomInfo, refresh }) => {
  const { id: reqRoomId } = roomInfo;
  if (reqRoomId === currentRoomId()) {
    const onAdd = async () => {
      const roomInfo = await RoomService.fetchRoom({ roomId: reqRoomId });
      const { queue } = roomInfo;
      PlayerManager.updateQueue(queue);
      SocketService.refresh("queue");
      refresh();
    };
    AddSongFlow.initiate({ type: "room", id: reqRoomId, onAdd });
  } else {
    ToastService.errorToast("You have not synced with this room");
  }
};

// return true if successfully sent message
const handleSendMsg = async ({ msg, roomInfo }) => {
  const { id: reqRoomId } = roomInfo;
  if (reqRoomId === currentRoomId()) {
    if (msg.length >= 50) {
      ToastService.errorToast("Message too long");
      return false;
    }
    SocketService.chat(msg);
    return true;
  } else {
    ToastService.errorToast("You have not synced with this room");
    return false;
  }
};

const handleLeave = async () => {
  const cri = currentRoomId();
  if (cri) {
    SocketService.leave();
  }
};

const handleSync = async ({ roomInfo }) => {
  const cri = currentRoomId();
  const { id: reqRoomId } = roomInfo;
  if (cri && cri !== reqRoomId) {
    SocketService.leave();
  }
  // join to new room
  const session = await RoomService.syncRoom({ roomId: reqRoomId });
  const { roomId, username, email, roomName } = session || {};
  if (!roomId || !username) return;
  PlayerManager.reset(roomInfo.queue);
  // refresh to all members
  setTimeout(() => {
    SocketService.sync({ username, roomId, email, roomName });
  }, 1000);
};

const handleThemeChange = async ({ roomInfo, refresh }) => {
  const { id: reqRoomId } = roomInfo;
  if (reqRoomId === currentRoomId()) {
    const isUpdated = await RoomService.update({
      roomId: reqRoomId,
      theme: true,
    });
    if (isUpdated) {
      SocketService.refresh("theme");
      refresh();
    }
  } else {
    ToastService.errorToast("You have not synced with this room");
    return false;
  }
};

export {
  handlePlay,
  handleRemove,
  handleAdd,
  handleSendMsg,
  handleSync,
  handleLeave,
  handleThemeChange,
};
